export const bookingStyles = {
  space: {
    dialogMargin: '20px',
  },
  buttons: {
    primaryLg: {
      variant: 'buttons.primary',
      minHeight: '63px',
    },
  },
  sizes: {
    tabListWidth: '430px',
  },
} as const;
